import BaseApi from './baseApi';
import ICustomerContacts from '../models/ICustomerContacts';
import IAuthentication from '../models/IAuthentication';
export default class CustomerContactsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Customers");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetCustomerContacts(customerId: string) : Promise<ICustomerContacts[]> {
        const json = this.getJsonRead(customerId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var customerContacts: ICustomerContacts[] = [];
            customerContacts = response.data as ICustomerContacts[];
            return customerContacts;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveCustomerContact(customerContact: ICustomerContacts) : Promise<string> {
        const json = this.getJsonSave(customerContact);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateCustomerContact(customerContact: ICustomerContacts) : Promise<boolean> {
        const json = this.getJsonUpdate(customerContact);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteCustomerContact(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "CustomersContacts",
            "conditions": [{
                "Item1": "CustomersContacts",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(customerContact: ICustomerContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": customerContact.name
            }, {
                "Item1": "Email",
                "Item2": customerContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": customerContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": customerContact.phoneNumber
            }, {
                "Item1": "IdCustomer",
                "Item2": customerContact.idCustomer
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "CustomersContacts"
        };
        return json;
    }

    private getJsonUpdate(customerContact: ICustomerContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": customerContact.name
            }, {
                "Item1": "Email",
                "Item2": customerContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": customerContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": customerContact.phoneNumber
            }, {
                "Item1": "IdCustomer",
                "Item2": customerContact.idCustomer
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "CustomersContacts",
            "keyvalue": customerContact.id
        };
        return json;
    }

    private getJsonRead(customerId: string) : any {
        const json = {
            "fields": [{
                "Item1": "CustomersContacts",
                "Item2": "id"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "name"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "email"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "phoneNumber"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "idCustomer"
            }],
            "tables": [{
                "Item1": "CustomersContacts"
            }, {
                "Item1": "ListPhonePrefixes"
            }],
            "joins": [{
                "Item1": "CustomersContacts",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "CustomersContacts",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "CustomersContacts",
                "Item2": "IdCustomer",
                "Item3": "=",
                "Item4": customerId
            }]
        };
        return json;
    }
}
